import DOMPurify from "dompurify";

// Force rel="noopener noreferrer" on any link that opens a new tab
// (prevents reverse-tabnabbing). Registered once at module load.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.hasAttribute("target")) {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

// Single strict config shared by every HTML render sink (article body,
// docs body, AI-assist preview). The `html` profile excludes SVG/MathML
// (mutation-XSS vectors) and script; we additionally forbid framing,
// embeds, and form elements, and disallow data-* attributes.
const CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: [
    "style", "form", "input", "button", "textarea", "select", "option",
    "iframe", "object", "embed", "link", "meta", "base",
  ],
  ALLOW_DATA_ATTR: false,
};

export function sanitizeHtml(dirty) {
  return DOMPurify.sanitize(dirty || "", CONFIG);
}
